import * as React from 'react';
import { List } from '../list';
import { Progress } from '../progress';
import styled from '../../styles/styled-components';
import { observer } from 'mobx-react';

interface FileUploadProps {
  uploads: { [key: string]: FileTransfer.UploadProgress };
}

@observer
export class FileUploadComp extends React.Component<FileUploadProps> {
  render() {
    var uploads = this.props.uploads;

    var uploadsInProgress = Object.keys(uploads)
      .map(key => ({ key, file: uploads[key] }))
      .filter(({ file }) => file.uploaded / file.total < 1);

    var listItems = uploadsInProgress.map(({ key, file }) => ({
      key,
      header: file.path,
      description: (
        <FixedWidthProgress progress={file.uploaded / file.total * 100} />
      ),
    }));

    return (
      <div>
        <h5 style={{ marginTop: 0, marginBottom: 0 }}>Uploading...</h5>
        <List items={listItems} />
      </div>
    );
  }
}

export function areFileUploadsInProgress(uploads: {
  [key: string]: FileTransfer.UploadProgress;
}) {
  return (
    Object.keys(uploads).filter(
      key => uploads[key].uploaded / uploads[key].total < 1,
    ).length !== 0
  );
}

const FixedWidthProgress = styled(Progress)`
  width: 200px;
`;
